import { createStorefrontApiClient } from '@shopify/storefront-api-client';

export const storefrontApiClient = createStorefrontApiClient({
	storeDomain: process.env.GATSBY_SHOPIFY_PRIMARY_DOMAIN || process.env.GATSBY_SHOPIFY_STORE_URL,
	apiVersion: process.env.GATSBY_SHOPIFY_STOREFRONT_API_VERSION,
	publicAccessToken: process.env.GATSBY_STOREFRONT_ACCESS_TOKEN,
});
